import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=aa09e242&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=aa09e242&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa09e242",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa09e242')) {
      api.createRecord('aa09e242', component.options)
    } else {
      api.reload('aa09e242', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=aa09e242&scoped=true&", function () {
      api.rerender('aa09e242', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Ya7mWATbsaJ9/JS/comp/PopupBox.vue"
export default component.exports